<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		class?: ClassValue;
		children?: Snippet;
	}

	const { class: classes, children }: Props = $props();

</script>

<div class="control-stack {classes} shadow-smooth-bottom-1">
	{@render children?.()}
</div>

<style>
	/* TODO: search input doesn't have border radius on primary element so label child is targeted too
		to fix it, try to have the border-radius on the primary element in search-input,
		by either moving it to the div or see if we can make the label primary element instead
	*/
	.control-stack :global(> :first-child:not(:last-child)),
	.control-stack :global(> :first-child:not(:last-child) label .input-container) {
		border-bottom-left-radius: 0 !important;
		border-bottom-right-radius: 0 !important;
		margin-bottom: 0 !important;
	}

	.control-stack :global(> *:not(:first-child):not(:last-child)),
	.control-stack :global(> *:not(:first-child):not(:last-child) label .input-container) {
		border-radius: 0 !important;
		border-top-width: 0 !important;
		margin-bottom: 0 !important;
		margin-top: 0 !important;
	}

	.control-stack :global(> :last-child:not(:first-child)),
	.control-stack :global(> :last-child:not(:first-child) label .input-container) {
		border-top-left-radius: 0 !important;
		border-top-right-radius: 0 !important;
		margin-top: 0 !important;
	}
</style>
